import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { getStore } from '../store/index.mjs';

const BaseIcon = forwardRef(
  (props, ref) => {
    const {
      width,
      height,
      // custom
      size,
      // rest
      ...otherProps
    } = props;
    const theme = getStore();
    const mergedProps = useMemo(() => {
      const _props = { ...otherProps };
      for (const _key in theme) {
        const key = _key;
        if (key === "size") continue;
        _props[key] = _props[key] ?? theme[key];
      }
      return _props;
    }, [otherProps, theme]);
    return /* @__PURE__ */ jsx(
      "svg",
      {
        ref,
        width: width ?? size ?? theme.width ?? theme.size,
        height: height ?? size ?? theme.height ?? theme.size,
        ...mergedProps
      }
    );
  }
);

export { BaseIcon };
//# sourceMappingURL=base-icon.mjs.map
